/**
 * Agent employee numbers excluded from Agent Payment Report, Agent Payment Summary,
 * and the Finance menu equivalents (AgentPaymentInfo / AgentPaymentSummary).
 * Match is by resolved employee number (from /agents) or eft.agentId when no agent row matches.
 */
const EXCLUDED_AGENT_PAYMENT_REPORT_NUMBERS = new Set([
  "148",
  "151",
  "152",
  "157",
  "158",
  "160",
  "161",
  "162",
  "163",
]);

function resolveAgentNumberForPaymentReport(eft, agents) {
  if (!eft) return "";
  const agent = (agents || []).find(
    (a) =>
      a.employeeNo?.toString() === String(eft.agentId) || a._id === eft.agentId,
  );
  if (agent?.employeeNo != null && agent.employeeNo !== "") {
    return String(agent.employeeNo).trim();
  }
  if (eft.agentId != null && eft.agentId !== "") {
    return String(eft.agentId).trim();
  }
  return "";
}

function isExcludedFromAgentPaymentReports(eft, agents) {
  const n = resolveAgentNumberForPaymentReport(eft, agents);
  return n !== "" && EXCLUDED_AGENT_PAYMENT_REPORT_NUMBERS.has(n);
}

/** Exclude rows from /agents API (e.g. Print Agent Report dropdown). */
function isAgentRecordExcludedFromPaymentReports(agent) {
  if (!agent || agent.employeeNo == null || agent.employeeNo === "") {
    return false;
  }
  return EXCLUDED_AGENT_PAYMENT_REPORT_NUMBERS.has(
    String(agent.employeeNo).trim(),
  );
}

// Named exports only — do not add `export default` here; CRA/webpack can treat the
// module as "default only" and break `import { isExcludedFromAgentPaymentReports }`.
export {
  EXCLUDED_AGENT_PAYMENT_REPORT_NUMBERS,
  resolveAgentNumberForPaymentReport,
  isExcludedFromAgentPaymentReports,
  isAgentRecordExcludedFromPaymentReports,
};
